export const selectCity = {
  Auth_SelectCity: "AUTH.SelectCity",
  Auth_SearchCity: "AUTH.SearchCity",
}